import classNames from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Slider, { CustomArrowProps, Settings } from 'react-slick';
import { bindActionCreators } from 'redux';

import * as Actions from '../../../common/services/customer/Actions';
import * as CustomerService from '../../../common/services/customer/Service';
import { CustomerDataDTO } from '../../../common/types/dto/CustomerDataDTO';
import { VehicleDataDTO } from '../../../common/types/dto/VehicleDataDTO';
import orbitDireita from '../../assets/images/icons/Cinzentos/setaOrbitDireita.svg';
import orbitEsquerda from '../../assets/images/icons/Cinzentos/setaOrbitEsquerda.svg';
import cssMessages from '../../assets/scss/Messages.scss';
import { RootState } from '../../base/RootReducer';
import { config } from '../../common/';
import { AppThunkDispatch } from '../../common/types';
import NoVehicle from '../../main/components/NoVehicle';
import css from './VehicleSelect.scss';

interface VehicleSelectState {
    vehcode: number;
    vehicles: VehicleDataDTO[];
}

export interface VehicleSelectProps {
    onChange: (selected: number) => void;
    isMini: boolean;
    defaultVehcode?: number;
}

interface ReduxStateProps {
    isCommunicating: boolean;
    customerInfo: CustomerDataDTO | undefined;
}

interface ReduxDispatchProps {
    customerActions: typeof Actions;
    customerServiceActions: CustomerService.ServiceActions;
}

interface PrimeCustomArrowProps extends CustomArrowProps {
    isMini?: boolean | null;
}

type VehicleSelectProperties =
    ReduxStateProps
    & ReduxDispatchProps
    & VehicleSelectProps;

const VehicleSelectV3: React.FC<VehicleSelectProperties> = (Props) => {
    const initialState: VehicleSelectState = {
        vehcode: Props.defaultVehcode ? Number(Props.defaultVehcode) : - 1,
        vehicles: [],
    };
    const [state, setState]: [VehicleSelectState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    const { t } = useTranslation();

    useEffect(() => {
        if (Props.customerInfo && Props.customerInfo.vehicles && Props.customerInfo.vehicles.length > 0) {
            setState({ vehicles: Props.customerInfo.vehicles });
            Props.onChange(state.vehcode >= 0 ? state.vehcode : Props.customerInfo.vehicles[0].vehcode);
        }
    }, [Props.customerInfo]);

    const buildVehicles = (vehicles: VehicleDataDTO[]) => {
        return vehicles.map((vehicleItem: VehicleDataDTO, index) => {
            if (Props.isMini) {
                return (
                    <React.Fragment key="vehicleItem">
                        <div className={!Props.isMini ? css.small : null}>
                            <div className={css.imageContainerMini} data-series={vehicleItem.series}>
                                <img className={css.vehicleImage} src={config.CosyImagesPath + vehicleItem.imgUrl} width="100%" />
                                {/*<img src={'https://sss19qly.claranet.pt/bmwprime/StaticFiles/cosyimages/WBBM/walkaround/2B31_300.png'} width="100%" />*/}
                            </div>
                            <div className={'my-bmw-servicos-value-service-banner'}>
                                <div className={classNames(['grid-container', 'pacote-orbit-info'])} style={{ paddingBottom: '40px', textAlign: 'center' }}>
                                    <h4>{vehicleItem.model}</h4>
                                    <span>{vehicleItem.licensePlate}</span>
                                </div>
                            </div>
                            {vehicles.length > 1 && <span className={'contador'}>&nbsp;Viatura&nbsp;{index + 1}&nbsp;/&nbsp;{vehicles.length}&nbsp;</span>}
                        </div>
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment key="vehicleItem">
                        <div className={'grid-x'}>
                            <div className={classNames(['columns', 'medium-6', 'small-12', 'padding-left-0'])}>
                                <h4 className={'modelo-viatura'}>{vehicleItem.model}</h4>
                                <ul className={classNames(['no-bullet', 'dados-viatura'])}>
                                    <li>
                                        <span className={'nome'}>{t('vehicleSelect.licensePlate')}:</span> <span className={'valor'}>{vehicleItem.licensePlate}</span>
                                    </li>
                                    <li>
                                        <span className={'nome'}>{t('vehicleSelect.model')}:</span> <span className={'valor'}>{vehicleItem.model}</span>
                                    </li>
                                    <li>
                                        <span className={'nome'}>{t('vehicleSelect.serialNumber')}:</span> <span className={'valor'}>{vehicleItem.vin}</span>
                                    </li>
                                </ul>
                            </div>
                            <div className={classNames(['columns', 'medium-6', 'small-12', 'padding-right-0'])}>
                                <div className={css.imageContainer} data-series={vehicleItem.series}>
                                    <img className={css.vehicleImage} src={config.CosyImagesPath + vehicleItem.imgUrl} />
                                    {/*<img className={css.vehicleImage} src={'sss-qly.bmwgroup.net/bmwprime/StaticFiles/cosyimages/WBBM/walkaround/2B31_300.png'} />*/}
                                </div>
                                {vehicles.length > 1 && <span className={'contador'}>&nbsp;Viatura&nbsp;{index + 1}&nbsp;/&nbsp;{vehicles.length}&nbsp;</span>}
                            </div>
                        </div>
                    </React.Fragment>
                );
            }
        });
    };

    function onChange(currentSlide: number) {
        const vehcode = state.vehicles[currentSlide].vehcode;
        Props.onChange(vehcode);
    }

    const PrevArrow = (props: PrimeCustomArrowProps) => {
        const { onClick } = props;
        return (
            <button type="button" onClick={onClick} data-role="none" className={classNames(['orbit-previous', css.arrowSlickPrev, (props.isMini ? css.miniArrowSlickPrev : null)])}>
                <img src={orbitEsquerda} height="13" />
            </button>
        );
    };

    const NextArrow = (props: PrimeCustomArrowProps) => {
        const { onClick } = props;
        return (
            <button type="button" onClick={onClick} data-role="none" className={classNames(['orbit-next', css.arrowSlickNext, (props.isMini ? css.miniArrowSlickNext : null)])}>
                <img src={orbitDireita} height="13" />
            </button>
        );
    };

    const settings: Settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: onChange,
        nextArrow: <NextArrow isMini={Props.isMini} />,
        prevArrow: <PrevArrow isMini={Props.isMini} />,
    };

    const vehVehicle = state.vehicles.find((x) => x.vehcode === state.vehcode);
    const indexOf = vehVehicle ? state.vehicles.indexOf(vehVehicle) : 0;
    return (
        <React.Fragment>
            <div className={'meu-perfil'}>
                <div className={'dados-pacotes'}>
                    {state.vehicles.length > 0 ?
                        <div className={'orbit'}>
                            <Slider {...settings} initialSlide={indexOf}>
                                {buildVehicles(state.vehicles)}
                            </Slider>
                        </div>
                        :
                        <NoVehicle />
                    }
                    {Props.customerInfo && Props.customerInfo.vehiclesFromOtherBrandsDetected &&
                        <div className={cssMessages.infoMsg}>
                            <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                            {t('profile:otherBrands1')}
                            <br />
                            {t('profile:otherBrands2')}<a target="_blank" href={config.BrandEnv === 'BMW' ? config.RedirectToMyMINI : config.RedirectToMyBMW}>{t('profile:otherBrands2Link')}</a>
                            <br />
                            {t('profile:otherBrands3')}
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    isCommunicating: store.customerState.customerData.isCommunicating,
    customerInfo: store.customerState.customerData.data.customerData,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    customerActions: bindActionCreators(Actions, dispatch),
    customerServiceActions: CustomerService.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSelectV3);
